import actions from 'redux-auto'
import i18n from 'i18next'
import Api from '#services/api'

export function pending(state) {
  return {
    ...state,
  }
}

export function fulfilled(state, payload, result) {
  return {
    ...state,
    hasNewActivities: result,
  }
}

export function rejected(state) {
  return {
    ...state,
  }
}

export async function action() {
  try {
    return await Api.getHasNewChatActivities()
  } catch (e) {
    actions.error.writeError({error: e})
    throw new Error(i18n.t(e.message))
  }
}
